import React, { useState, useEffect, useContext } from "react";
import { Grid, makeStyles, withStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import { getClientTypes } from "../../../../API/Entity/DocumentRequest";
import SearchableSelect from "../../../../Component/Forms/SearchableSelect";
import styles from "./styles";

const ClientTypeSelector = (props) => {
  const { request, entity, clientTypeError, onChange } = props;
  const { t } = useTranslation();
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);
  const [clientTypes, setClientTypes] = useState([]);
  const [clientType, setClientType] = useState(null);
  const [clientTypeOptions, setClientTypeOptions] = useState([]);

  const { showErrorMessage } = useContext(ModalDialogContext);

  useEffect(() => {
    const loadClientTypes = async () => {
      try {
        setIsLoading(true);
        const result = await getClientTypes(entity.id);
        const { data = [] } = result || {};
        setClientTypes(data);
        const clientTypeOptions = [];
        for (let ct of data) {
          clientTypeOptions.push({
            label: ct.client_type,
            value: ct.id,
          });
        }
        setClientTypeOptions(clientTypeOptions);
      } catch (error) {
        showErrorMessage({ error });
      }
      setIsLoading(false);
    };
    if (entity) {
      loadClientTypes();
    }
  }, [entity]);

  useEffect(() => {
    if (clientTypes) {
      if (clientType) {
        const ct = clientTypes.find((ct) => ct.id === clientType.value);
        if (!ct) {
          setClientType(null);
          onChange(null);
        }
      } else {
        let ct;
        const { records = [] } = request;
        const r = records.find((r) => r.entity.id === entity.id);
        if (r) {
          ct = r.clientType;
        }
        if (!ct && clientTypes.length === 1) {
          ct = { id: clientTypes[0].id, name: clientTypes[0].client_type };
        }
        if (ct) {
          setClientType({
            label: ct.name,
            value: ct.id,
          });
          onChange(ct);
        }
      }
    }
  }, [request, entity, clientTypes]);

  const handleClientTypeChange = (newValue) => {
    setClientType(newValue);
    onChange({ id: newValue.value, name: newValue.label });
  };

  return (
    <Grid item xs={12}>
      <SearchableSelect
        label={t(
          "labels.record.documentRequest.steps.recordReviewStep.customerType",
        )}
        options={clientTypeOptions}
        value={clientType}
        changeHandler={handleClientTypeChange}
        disableClearable={true}
        required={true}
      />
      <div className={classes.errorText}>{clientTypeError}</div>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(ClientTypeSelector);
